import * as React from "react"
import {Avatar, Box} from "@mui/material";
import {TooltipSeeker} from "@ui-seeker/core"


export default function CommonIconButton({ remaining }) {
    return <TooltipSeeker title="To see additional information, click on 'View Details'">
        <Box display="flex" justifyContent="center">
            <Avatar sx={{
                width: 35,
                height: 29,
                fontSize: '0.8rem'
            }}>
                +{remaining}
            </Avatar>
        </Box>
    </TooltipSeeker>
}